import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Alert, Box, Button, Typography } from '@mui/material';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import MembersPage from '../pages/MembersPage';
import MemberDetailPage from '../pages/MemberDetailPage';

const OperationsHeading = ({ detail }) => (
  <Box sx={{ maxWidth: 1280, mx: 'auto', px: { xs: 2, sm: 3, lg: 4 }, pt: { xs: 2.5, md: 3.5 } }}>
    <Button
      component={RouterLink}
      to="/modernwash-ops"
      size="small"
      startIcon={<ArrowBackRoundedIcon />}
      sx={{ color: 'text.secondary', mb: 1.25 }}
    >
      ModernWash 전주점 운영 홈
    </Button>
    <Typography component="h1" sx={{ fontSize: { xs: 24, md: 29 }, fontWeight: 900, letterSpacing: '-0.04em' }}>
      {detail ? '기존 회원 상세' : '기존 회원 조회'}
    </Typography>
    <Alert severity="info" variant="outlined" sx={{ mt: 1.25, borderRadius: 2.5 }}>
      ModernWash V1 원천을 읽기 전용으로 확인합니다. 이 목록과 상세의 구독 상태는 Mogoo 세차 권리 판정에 사용되지 않습니다.
    </Alert>
  </Box>
);

/** Fixed Jeonju/V1 history member list. No write actions or source toggle. */
export const ModernWashOperationsMembers = () => (
  <Box sx={{ pb: 4 }}>
    <OperationsHeading />
    <Box sx={{ maxWidth: 1280, mx: 'auto', px: { xs: 2, sm: 3, lg: 4 }, pt: 3 }}>
      <MembersPage
        fixedDataSource="modernwash"
        memberDetailBasePath="/modernwash-ops/members"
        title="ModernWash 전주점 기존 회원"
        description="V1 원천 · 읽기 전용"
      />
    </Box>
  </Box>
);

/** Direct V1 read-only member detail; intentionally bypasses Mogoo member fallback. */
export const ModernWashOperationsMemberDetail = () => (
  <Box sx={{ pb: 4 }}>
    <OperationsHeading detail />
    <Box sx={{ maxWidth: 1280, mx: 'auto', px: { xs: 2, sm: 3, lg: 4 }, pt: 2 }}>
      <MemberDetailPage legacyOnly backPath="/modernwash-ops/members" />
    </Box>
  </Box>
);

export default ModernWashOperationsMembers;
